export const SET_LANG = 'SET_LANG';

export default function (value) {
    return {
        type: SET_LANG,
        value,
    };
}